import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import TopicCard from "@/components/feature/TopicCard";
import ShareButtons from "@/components/feature/ShareButtons";
import SectionHeading from "@/components/feature/SectionHeading";
import CommentSection from "@/components/feature/CommentSection";
import ContentMissing from "@/components/feature/ContentMissing";
import {
  getTopicById,
  getFilmsByIds,
  getStarsByIds,
  getRelatedTopics,
} from "@/lib/content";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function TopicDetail() {
  const { id } = useParams<{ id: string }>();
  const topic = id ? getTopicById(id) : undefined;

  useDocumentMeta({
    title: topic ? `${topic.title} - 巨乳娱乐资讯网` : "网络话题 - 巨乳娱乐资讯网",
    description: topic
      ? `${topic.excerpt} 巨乳娱乐资讯网网络话题栏目持续追踪相关讨论。`
      : "网络话题详情页，聚合话题正文、相关作品与人物。",
    keywords: topic
      ? `${topic.tag},网络话题,娱乐资讯,${topic.title},巨乳娱乐资讯网`
      : "网络话题,娱乐资讯,巨乳娱乐资讯网",
  });

  if (!topic) {
    return <ContentMissing message="该话题可能已被移除，或链接有误。" />;
  }

  const relatedFilms = getFilmsByIds(topic.filmIds);
  const relatedStars = getStarsByIds(topic.starIds);
  const moreTopics = getRelatedTopics(topic);

  return (
    <div className="mx-auto w-full max-w-4xl px-4 py-6 md:px-8 md:py-8">
      <Breadcrumb
        items={[
          { label: "首页", to: "/" },
          { label: "网络话题", to: "/category/topics" },
          { label: topic.tag },
        ]}
      />

      <article className="mt-4">
        <span className="inline-block rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
          {topic.tag}
        </span>
        <h1 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
          {topic.title}
        </h1>
        <div className="mt-3 flex flex-wrap items-center gap-4 text-xs text-foreground-500 md:text-sm">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" aria-hidden="true"></i>
            {topic.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-3-line" aria-hidden="true"></i>
            前端演示话题
          </span>
        </div>

        <div className="mt-5 overflow-hidden rounded-lg bg-background-100">
          <div className="aspect-[16/9] w-full">
            <img
              src={topic.cover}
              alt={`${topic.title} 话题配图`}
              title={`${topic.title} 网络话题 巨乳娱乐资讯网`}
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-5">
          {topic.content.map((block, index) => {
            if (block.type === "image") {
              return (
                <figure
                  key={`img-${index}`}
                  className="overflow-hidden rounded-lg bg-background-100"
                >
                  <div className="aspect-[16/9] w-full">
                    <img
                      src={block.value}
                      alt={`${topic.title} 配图`}
                      title={`${topic.title} 网络话题 巨乳娱乐资讯网`}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                </figure>
              );
            }
            return (
              <p
                key={`text-${index}`}
                className="text-sm leading-loose text-foreground-700 md:text-base"
              >
                {block.value}
              </p>
            );
          })}
        </div>

        {(relatedFilms.length > 0 || relatedStars.length > 0) && (
          <section className="mt-8 rounded-lg border border-background-200 bg-background-50 p-5">
            <h2 className="mb-4 font-heading text-base font-bold text-foreground-950 md:text-lg">
              相关影视与人物
            </h2>
            {relatedFilms.length > 0 && (
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-xs text-foreground-500">影视作品：</span>
                {relatedFilms.map((film) => (
                  <Link
                    key={film.id}
                    to={`/detail/film/${film.id}`}
                    className="whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-700 transition-colors hover:bg-primary-200"
                  >
                    {film.title}
                  </Link>
                ))}
              </div>
            )}
            {relatedStars.length > 0 && (
              <div className="mt-3 flex flex-wrap items-center gap-2">
                <span className="text-xs text-foreground-500">相关人物：</span>
                {relatedStars.map((star) => (
                  <Link
                    key={star.id}
                    to={`/detail/star/${star.id}`}
                    className="whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900 transition-colors hover:bg-accent-200"
                  >
                    {star.name}
                  </Link>
                ))}
              </div>
            )}
          </section>
        )}

        <div className="mt-8">
          <ShareButtons title={`${topic.title} - 巨乳娱乐资讯网`} />
        </div>
      </article>

      <CommentSection />

      {moreTopics.length > 0 && (
        <section className="mt-10">
          <SectionHeading title="相关推荐话题" moreTo="/category/topics" />
          <div className="flex flex-col gap-3">
            {moreTopics.map((item) => (
              <TopicCard key={item.id} topic={item} variant="row" />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}